
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class LotCreationDetailsDialog extends _Ext.ItemEditorDialog<LotCreationDetailsRow> {

        protected getFormKey() { return LotCreationDetailsForm.formKey; }
        protected getLocalTextPrefix() { return LotCreationDetailsRow.localTextPrefix; }
        protected getDeletePermission() { return LotCreationDetailsRow.deletePermission; }
        protected getInsertPermission() { return LotCreationDetailsRow.insertPermission; }
        protected getUpdatePermission() { return LotCreationDetailsRow.updatePermission; }
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }
        public Closing: boolean;
        public AtbId: number;
        protected form = new LotCreationDetailsForm(this.idPrefix);
        constructor() {
            super();

            q.hideEditorLabel(this.form.ItemsDetails);
            q.setGridEditorHeight(this.form.ItemsDetails, 300)
            q.hideEditorToolbar(this.form.ItemsDetails);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.AllotedPieces);
            q.setTextRightAlign(this.form.AllotedWeight);
            q.setTextRightAlign(this.form.AllotedNetWeight);
            q.setTextRightAlign(this.form.BalancePieces);
            q.setTextRightAlign(this.form.BalanceWeight);
            q.setTextRightAlign(this.form.BalanceNetWeight);
            q.setTextRightAlign(this.form.NewPieces);
            q.setTextRightAlign(this.form.NewGrossWeight);
            q.setTextRightAlign(this.form.NewNetWeight);
            q.setTextRightAlign(this.form.NewStoneWeight);

            this.form.ProductTypeId.changeSelect2(e => {
                this.checkAttribute();
            });
            this.form.CategoryId.changeSelect2(e => {
                this.form.SubCategoryId.CategoryId = parseInt(this.form.CategoryId.value);
                this.form.SubCategoryId.updateItems();
            })

            this.form.SubCategoryId.changeSelect2(e => {
                this.checkAttribute();
            });
            this.form.BrandId.changeSelect2(e => {
                this.checkAttribute();
            })
            this.form.CollectionId.changeSelect2(e => {
                this.checkAttribute();
            });
            this.form.SuperTypeId.changeSelect2(e => {
                this.checkAttribute();
            });
            this.form.NewPieces.changeSelect2(e => {
                var pieces = this.form.NewPieces.value;
                if (pieces > 0) {
                    var balancepieces = this.form.BalancePieces.value;
                    if (pieces > balancepieces) {
                        q.Alert('', 'Cannot be greater than Balance Pieces', 2999, false);
                        this.form.NewPieces.value = 0;
                        this.form.NewGrossWeight.value = 0;
                        this.form.NewNetWeight.value = 0;
                        this.form.NewStoneWeight.value = 0;
                        return;
                    }

                    this.form.NewGrossWeight.value = 0;
                    this.form.NewNetWeight.value = 0;
                    this.form.NewStoneWeight.value = 0;
                }
            });
            this.form.NewGrossWeight.changeSelect2(e => {
                var grossweight = this.form.NewGrossWeight.value;
                var balanceweight = this.form.BalanceWeight.value;
                if (grossweight > balanceweight) {
                    q.Alert('', 'Cannot be greater than Balance Weight', 2999, false);
                    this.form.NewGrossWeight.value = 0;
                    return;
                }

                this.form.NewNetWeight.value = 0;
                this.form.NewStoneWeight.value = 0;
                this.form.NewNetWeight.value = grossweight;
            })
            this.form.NewStoneWeight.changeSelect2(e => {
                var newstoneweight = this.form.NewStoneWeight.value;
                var newgrossweight = this.form.NewGrossWeight.value;
                if (newstoneweight > newgrossweight) {
                    q.Alert('', 'Cannot be greater than Gross Weight', 2999, false);
                    this.form.NewStoneWeight.value = 0;
                    return;
                }
                this.form.NewNetWeight.value = newgrossweight - newstoneweight;
            });
            this.form.NewNetWeight.changeSelect2(e => {
                var newnetweight = this.form.NewNetWeight.value;
                var newstoneweight = this.form.NewStoneWeight.value;
                var newgrossweight = this.form.NewGrossWeight.value;
                if (newnetweight > newgrossweight) {
                    q.Alert('', 'Cannot be greater than Gross Weight', 2999, false);
                    this.form.NewStoneWeight.value = 0;
                    return;
                }
                this.form.NewStoneWeight.value = newgrossweight - newnetweight;
            });

            this.form.GenerateLot.onClick = (e) => {
                var _entity = this.entity;


                _entity.Pieces = this.form.Pieces.value - this.form.AllotedPieces.value;
                _entity.Weight = this.form.Weight.value - this.form.AllotedWeight.value;
                _entity.NetWeight = this.form.NetWeight.value - this.form.AllotedNetWeight.value;

                var lotpieces = this.form.Pieces.value;
                var lotweight = this.form.Weight.value;

                var allotedpieces = this.form.AllotedPieces.value;
                var allotedweight = this.form.AllotedWeight.value;

                var newpieces = this.form.NewPieces.value;
                var newweight = this.form.NewGrossWeight.value;

                if (newpieces == 0 || newweight == 0) {

                    q.alert('', 'Invalid Value(Please Enter Pieces/Weight)', true, 3999);
                    return;
                }
                if ((newpieces + allotedpieces) == lotpieces && (newweight + allotedweight) != lotweight) {

                    q.alert('', 'Invalid Value(All Weight needs to be consumed if All Pieces are Selected!)', true, 3999);
                    return;
                }

                var baseitemid = this.form.ProductTypeId.value == undefined ? 0 : this.form.ProductTypeId.value;
                var typeid = this.form.CategoryId.value == undefined ? 0 : this.form.CategoryId.value;
                var subtypeid = this.form.SubCategoryId.value == undefined ? 0 : this.form.SubCategoryId.value;
                var brandid = this.form.BrandId.value == undefined ? 0 : this.form.BrandId.value;
                var collectionid = this.form.CollectionId.value == undefined ? 0 : this.form.CollectionId.value;
                var supertypeid = this.form.SuperTypeId.value == undefined ? 0 : this.form.SuperTypeId.value;

                if (baseitemid == "" || typeid == "" || subtypeid == ""
                    || brandid == "" || collectionid == "" || supertypeid == "") {
                    Q.alert('All Attributes need to be selected');
                    this.form.NewPieces.value = 0;
                    this.form.NewGrossWeight.value = 0;
                    this.form.NewNetWeight.value = 0;
                    this.form.NewGrossWeight.value = 0;
                    return;
                }

                this.entity.ProductTypeId = parseInt(baseitemid.toString());
                this.entity.CategoryId = parseInt(typeid.toString());
                this.entity.SubCategoryId = parseInt(subtypeid.toString());
                this.entity.BrandId = parseInt(brandid.toString());
                this.entity.CollectionId = parseInt(collectionid.toString());
                this.entity.SuperTypeId = parseInt(supertypeid.toString());


                _entity.Pieces = this.form.NewPieces.value;
                _entity.Weight = this.form.NewGrossWeight.value;
                _entity.NetWeight = this.form.NewNetWeight.value;
                _entity.StoneWeight = this.form.NewGrossWeight.value - this.form.NewNetWeight.value;


                if ((allotedpieces + newpieces) <= lotpieces && (allotedweight + newweight) <= lotweight) {
                    var _productId = 0;
                    if (this.form.NewProductCode.value != "")
                        _productId = parseInt(this.form.NewProductId.value);
                    else
                        _productId = this.entity.ProductId;
                    this.form.ItemsDetails.setData(_entity, _productId, this.AtbId, newpieces, newweight, this.entity.StockId);
                }
                else
                    Q.notifyError('Invalid Value(New Lot) should be less than Pieces/Weight');
               
                this.form.NewPieces.element.focus;
                this.calculateAllocation();
            };

            var fieldEditor: JQuery = this.form.NewProductCode.element.closest(".editor");
            fieldEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.form.AttributeId.value != "") {
                this.AtbId = parseInt(this.form.AttributeId.value);
            }
            this.calculateAllocation();
        }
        checkAttribute() {
            var baseitemid = parseInt(this.form.ProductTypeId.value) == undefined ? 0 : parseInt(this.form.ProductTypeId.value);
            var typeid = parseInt(this.form.CategoryId.value) == undefined ? 0 : parseInt(this.form.CategoryId.value);
            var subtypeid = parseInt(this.form.SubCategoryId.value) == undefined ? 0 : parseInt(this.form.SubCategoryId.value);
            var brandid = parseInt(this.form.BrandId.value) == undefined ? 0 : parseInt(this.form.BrandId.value);
            var collectionid = parseInt(this.form.CollectionId.value) == undefined ? 0 : parseInt(this.form.CollectionId.value);
            var supertypeid = parseInt(this.form.SuperTypeId.value) == undefined ? 0 : parseInt(this.form.SuperTypeId.value);

            var attributeid;
            OMS.CommonAttributesService.GetProductATB({

                ProductTypeId: baseitemid,
                CategoryId: typeid,
                SubCategoryId: subtypeid,
                BrandId: brandid,
                CollectionId: collectionid,
                SuperTypeId: supertypeid

            }, response => {
                attributeid = response.AttributeId
            }, { async: false }
            );
            if (attributeid.length > 0) {
                this.AtbId = attributeid[0].AttributeId;
            }
            else {
                this.AtbId = 0;
            }

        }
        protected validateBeforeSave() {
            super.validateBeforeSave();
            var items = this.form.ItemsDetails.getItems();
            var totalweight = this.form.Weight.value;
            var totalpieces = this.form.Pieces.value;
            var newweight = 0;
            var newpieces = 0;
            for (var i = 0; i < items.length; i++) {
                newweight += items[i].Weight;
                newpieces += items[i].Pieces;
            }
            if (totalweight < newweight) {
                Q.alert('Total Weights do not match');
                return false;
            } else if (totalweight == newweight && totalpieces > newpieces) {
                Q.alert('All weight canot be consumed');
                return false;
            } else
                return true;
        }

        protected inplaceSearchClick(e: any): void {
            var T = this.isViewMode();

            if (!this.isViewMode()) {
                var grid = Common.ProductSelectGrid;
                var producttypeid = parseInt(this.form.ProductTypeId.value);
                var filters: _Ext.SelectGridFilters = {
                    ProductTypeId: producttypeid,
                    FilterItems: 5
                }
                var pickerDialog = new _Ext.GridItemPickerDialog({
                    gridType: grid, multiple: false, title: "Select New Product", GridFilters: filters
                });


                pickerDialog.onSuccess = (selectedItems: OMS.ProductMasterRow[]) => {
                    if (selectedItems.length > 0) {
                        var product = selectedItems[0]
                        this.form.NewProductId.value = product.ProductId.toString();
                        this.form.NewProductCode.value = product.ProductCode;
                        this.form.BrandId.value = product.BrandId.toString();
                        this.form.CollectionId.value = product.CollectionId.toString();
                        this.form.SuperTypeId.value = product.SuperTypeId.toString();
                        this.form.CategoryId.value = product.CategoryId.toString();
                        this.form.SubCategoryId.value = product.SubCategoryId.toString();
                        this.form.ProductTypeId.value = product.ProductTypeId.toString();
                        this.checkAttribute();

                    }
                }
                pickerDialog.dialogOpen();
            }
            else {
                q.Alert("View Mode", "Can not make changes in view mode", 2000, false);
            }
        }

        calculateAllocation() {
            var items = this.form.ItemsDetails.getItems();
            var pcs = 0; var wt = 0; var nwt = 0;
            for (var i = 0; i < items.length; i++) {
                pcs += items[i].Pieces;
                wt += items[i].Weight;
                nwt += items[i].NetWeight;

            }
            this.form.AllotedPieces.value = pcs;
            this.form.AllotedWeight.value = wt;
            this.form.AllotedNetWeight.value = nwt;

            this.form.BalancePieces.value = this.form.Pieces.value - pcs;
            this.form.BalanceWeight.value = this.form.Weight.value - wt;
            this.form.BalanceNetWeight.value = this.form.NetWeight.value - nwt;

            
        }
    }
}